import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { AppleIcon, SmartphoneIcon } from 'lucide-react';
export function CtaSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  return <section ref={ref} id="download" className="relative py-32 px-6 overflow-hidden bg-[#15193D]" data-id="element-10">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden" data-id="element-11">
        <div className="absolute top-20 left-20 w-[500px] h-[500px] bg-[#2A3166] rounded-full blur-[100px] opacity-50" data-id="element-12"></div>
        <div className="absolute bottom-20 right-20 w-[400px] h-[400px] bg-[#3B4485] rounded-full blur-[100px] opacity-40" data-id="element-13"></div>
      </div>

      {/* Sparkle decorations */}
      <div className="absolute top-20 right-1/4 text-[#FBF3EA]/30 text-5xl" data-id="element-14">
        ✦
      </div>
      <div className="absolute bottom-20 left-1/4 text-[#FBF3EA]/20 text-6xl" data-id="element-15">
        ✦
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.6
    }} className="relative max-w-4xl mx-auto text-center" data-id="element-16">
        <h2 className="text-6xl md:text-7xl lg:text-[80px] font-black text-[#FBF3EA] mb-8 tracking-tight leading-[1.05]" style={{
        fontFamily: 'Fraunces, serif'
      }} data-id="element-17">
          Ready to bring your family together?
        </h2>

        <p className="text-xl md:text-2xl text-[#FBF3EA]/80 mb-14 max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-18">
          Download Famday today and start managing your family life with ease.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-5 justify-center" data-id="element-19">
          <button className="bg-[#FBF3EA] text-[#15193D] px-10 py-5 rounded-2xl font-semibold hover:bg-white transition-all hover:scale-105 flex items-center justify-center gap-4 shadow-2xl" data-id="element-20">
            <AppleIcon className="w-8 h-8" data-id="element-21" />
            <div className="text-left" data-id="element-22">
              <div className="text-sm opacity-80 font-medium" data-id="element-23">
                Download on the
              </div>
              <div className="text-xl font-bold" data-id="element-24">App Store</div>
            </div>
          </button>

          <div className="bg-white/10 border border-white/20 text-white/50 px-10 py-5 rounded-2xl flex items-center justify-center gap-4 cursor-default backdrop-blur-sm" data-id="element-25">
            <SmartphoneIcon className="w-8 h-8" data-id="element-26" />
            <div className="text-left" data-id="element-27">
              <div className="text-sm opacity-80 font-medium" data-id="element-28">Google Play</div>
              <div className="text-xl font-bold" data-id="element-29">Coming Soon</div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}